import React, { useState } from 'react';

import { Box, Tab, Tabs } from '@mui/material';
import { useDebouncedCallback } from 'use-debounce';

import {
  getInboundInvoiceListAction,
  getInboundTaskDocumentListAction,
} from 'redux-stores/actions';

import { CustomTabPanel, ListPage } from '../commons/components';

import {
  InboundInvoiceListTable,
  InboundTaskDocumentListTable,
} from './components';

export const InboundListPage: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (
    event: React.SyntheticEvent,
    newTabValue: number,
  ): void => {
    setTabValue(newTabValue);
  };

  const updateInboundListDebounce = useDebouncedCallback(
    (_searchParams, _location, _dispatch) => {
      switch (tabValue) {
        case 0:
          _dispatch(
            getInboundTaskDocumentListAction({
              searchParams: _searchParams,
              locationId: _location,
            }),
          );
          break;
        case 1:
          _dispatch(
            getInboundInvoiceListAction({
              searchParams: _searchParams,
              locationId: _location,
            }),
          );
          break;
        default:
      }
    },
    200,
    { maxWait: 1000 },
  );

  return (
    <ListPage updateListSearchDebounce={updateInboundListDebounce}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleChange}>
          <Tab label="Inbound Task Document" />
          <Tab label="Inbound Invoice" />
        </Tabs>
      </Box>
      <CustomTabPanel value={tabValue} index={0}>
        <InboundTaskDocumentListTable />
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={1}>
        <InboundInvoiceListTable />
      </CustomTabPanel>
    </ListPage>
  );
};
